import { FormDialog } from "../../components/FormDialog/FormDialog";

const ConnectorScheduleDialog = ({ formId, readOnly, saveConnectorScheduleData, uiSchema, scheduleSchema, formData, handleFormChange }) => {

    return (
        <FormDialog formId={formId}
            formData={formData}
            uiSchema={uiSchema}
            schema={scheduleSchema}
            handleFormChange={handleFormChange}
            readOnly={readOnly}
            saveFormData={saveConnectorScheduleData}
        />
    );

}

export default ConnectorScheduleDialog;
